import React, { useMemo } from 'react';
import { TypedMemo } from '../../common/types';
import { useCoverEditor } from '../CoverEditorContext';
import { KeepDesignCard } from '../publicMode/KeepDesignCard';
import { CoverInspector } from './CoverInspector';
import { EffectInspector } from './EffectInspector';
import { TextInspector } from './TextInspector';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the cover editor; each part uses its own slice of it */
import styles from '../CoverEditor.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * The right column (design cover-editor b1): the inspector of the selected thing: a text box, an
 * effect, or the cover itself with nothing selected.
 */
const InspectorComponent: React.FC = () => {
  const { state, publicTool } = useCoverEditor();
  const { selection, doc } = state;
  const box = useMemo(
    () => (selection?.kind === 'text' ? doc.texts.find((text) => text.id === selection.id) : undefined),
    [doc.texts, selection]
  );
  const effect = useMemo(
    () => (selection?.kind === 'effect' ? doc.effects.find((item) => item.id === selection.id) : undefined),
    [doc.effects, selection]
  );
  let body = <CoverInspector />;
  if (box !== undefined) {
    body = <TextInspector key={box.id} box={box} />;
  } else if (effect !== undefined) {
    body = <EffectInspector key={effect.id} effect={effect} />;
  }
  return (
    <aside className={styles.inspector}>
      {body}
      {publicTool !== undefined && <KeepDesignCard tool={publicTool} />}
    </aside>
  );
};

export const Inspector = TypedMemo(InspectorComponent);
